__turbopack_context__.v({
  "buzzLoader": "Gnb6xa_buzzLoader",
  "buzzText": "Gnb6xa_buzzText",
  "userBuzz": "Gnb6xa_userBuzz",
  "withGradient": "Gnb6xa_withGradient",
});
